import React from 'react'
import { useNavigate } from 'react-router-dom'
import './Footer.scss';

// import { useLocation } from "react-router-dom";

export default function Footer({ WebSitePages,Companies,CategoryInfo }) {
    const Navigate = useNavigate()
    return (
        <div className="Footer">
            <div className="FooterMenuAnddSign">
                <div className="HomePageSignUp">
                    <div className="HomePageSignUpBox">
                        <div className="HomePageSignUpLeft">
                            <h1>Sign up for Free <br /> Projects Information</h1>
                            <h2>Sign up to get free project <br /> cost info in your inbox.</h2>
                        </div>
                        <div className="HomePageSignUpRight">
                            <input placeholder="Email Address" type="text" />
                            <button>Sign me up</button>
                        </div>
                    </div>
                </div>
                <div className="FooterTop">

                    <div className="SiteMapDiv">
                        <h1>HandyBy</h1>
                        {CategoryInfo.map((A, index) =>
                            <a key={index} href={`category/${A.UrlCategory.toLowerCase()}`}>{A.Category}</a>
                        )}
                    </div>

                    <div className="SiteMapDiv">
                        <h1>Top 5 In</h1>
                        <a href="/pros/air-duct">Air Duct</a>
                        <a href="/pros/chimney-fireplace">Chimney Sweep</a>
                        <a href="/pros/dryer-vent">Dryer Vent</a>
                    </div>
                    <div className="SiteMapDiv">
                        <h1>Companies</h1>
                        {Companies ? Companies.map((A, index) => <a key={index} href={`/pro/${A.nameUrl}`}>{A.name}</a>) : null}
                    </div>
                </div>
            </div>
            <div className="FooterBottom">
                <div className="FooterBottomRight">
                    <h1>HandyBy.com</h1>
                </div>
                <div className="FooterBottomLeft">
                    <a href="/privacy-policy">privacy policy</a>
                    <a href="/terms-of-use">terms of use</a>
                    <a href="/sitemap">site map</a>
                    <a href="/do-not-sell">do not sell or share my personal information</a>
                </div>
            </div>
        </div>
    )
}
